import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { StructExam } from "../model/exam/exam";
import { Candidate, Exam } from "../model/exam/result";
import * as echarts from "echarts";
import V from "@/store/vuex-store";
import { Param } from "../model/exambuilder/exam-v2";

export class CandidateSubmitFinish extends Model {
  count = 0;
  list: Candidate[] = [new Candidate()];
}
//首页 顶部信息
export class DashTopData extends Model {
  candidateSubmitFinish = new CandidateSubmitFinish(); //今日面试完成
  candidateNoAudit = new CandidateSubmitFinish(); //全部 待评估人数
  examCommonlyUsedList: StructExam[] = [new StructExam()]; //常用面试
  exportExcel = {
    exporting: 0,
    fail: 0,
    finish: 0
  };
  email = {
    fail: 0,
    success: 0
  };
  mobile = {
    fail: 0,
    sending: 0,
    success: 0
  };

  static get(companyId: number) {
    return request
      .post("aiExam/dashboard/overview", { companyId, examType: V.getExamType })
      .then(res => {
        return new DashTopData().assign(res.data.data);
      });
  }
}

export class T extends Model {
  create = 0; //新增
  login = 0; //填写
  submitFinish = 0; //完成
  auditPass = 0; //通过
}
export class D extends Model {
  headers: string[] = [""];
  rowCreate: number[] = [0];
  rowLogin: number[] = [0];
  rowSubmitFinish: number[] = [0];
  rowAuditPass: number[] = [0];
}
//人数监控
export class PeopleData extends Model {
  count = new T(); //
  detail = new D();

  static get(companyId: number, examId: number, daysLimit: number) {
    return request
      .post("aiExam/dashboard/monitor", {
        companyId,
        examId,
        daysLimit,
        examType: V.getExamType
      })
      .then(res => {
        return new PeopleData().assign(res.data.data);
      });
  }
}

export class B extends Model {
  headers: string[] = [""];
  row: number[] = [0];
}
//考试开始时间 时长
export class TimeData extends Model {
  byBeginTime = new B(); //
  byTimeDuration = new B();

  static get(companyId: number) {
    return request
      .post("aiExam/dashboard/analyse", { companyId, examType: V.getExamType })
      .then(res => {
        return new TimeData().assign(res.data.data);
      });
  }
}

//所有面试
export class AllExam extends Model {
  count = 0; //
  list: Exam[] = [new Exam()];

  static get(companyId: number) {
    return request
      .post("aiExam/company/examAll", { companyId, examType: V.getExamType })
      .then(res => {
        return new AllExam().assign(res.data.data);
      });
  }
}
export class DataWatchObj extends Model {
  // byBeginTime:
}

//面试数据
export class ExamWatch extends Model {
  static get(param: { examId: number; companyId: number }) {
    return request
      .post("aiExam/dashboard/myInterview", {
        ...param,
        examType: V.getExamType
      })
      .then(res => {
        return res.data.data;
      });
  }
}

//时间段监控
export class DataWatch extends Model {
  static get(param: { companyId: number; examId: number; daysLimit: number }) {
    return request
      .post("aiExam/dashboard/observe", { ...param, examType: "normal" })
      .then(res => {
        return res.data.data;
      });
  }
}

//添加常用面试
export class AddAlways extends Model {
  static set(params: any) {
    params = { ...params, examType: V.getExamType };
    return request
      .post("aiExam/company/examMarkCommonlyUsed", params)
      .then(res => {
        return res;
      });
  }
}

const ecOptionLD = {
  color: ["#3046C4", "#7C53F0", "#83CBF4", "#84DFBD"],

  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      label: {
        backgroundColor: "#6a7985"
      }
    }
  },
  legend: {
    itemGap: 24,
    icon: "circle",
    itemHeight: 8,
    itemWidth: 8,
    top: "5%",
    data: ["新增候选人数", "填写信息人数", "完成面试人数", "通过人数"],
    selected: {
      新增候选人数: true,
      填写信息人数: true,
      完成面试人数: true,
      通过人数: true
    } // 不需要显示的设置为false
  },

  grid: {
    left: "3%",
    right: "3%",
    bottom: "3%",
    containLabel: true
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: false,
      data: [""],
      axisLabel: {
        alignMinLabel: "left",
        alignMaxLabel: "right"
      },
      axisTick: {
        inside: true, //刻度
        lineStyle: {
          color: "#DEEAFF"
        }
      }
    }
  ],
  yAxis: [
    {
      type: "value"
    }
  ],
  series: [
    {
      name: "新增候选人数",
      type: "line",
      stack: "Total",
      smooth: true,
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(48, 70, 196, 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(48, 70, 196, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [98, 92, 120, 80, 111, 102, 91]
    },
    {
      name: "填写信息人数",
      type: "line",
      stack: "Total2",
      smooth: true,
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(124, 83, 240 , 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(124, 83, 240, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [51, 53, 59, 50, 52, 54, 58]
    },
    {
      name: "完成面试人数",
      type: "line",
      stack: "Total3",
      smooth: true,
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(131, 203, 244 , 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(131, 203, 244, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [34, 33, 31, 39, 36, 30, 35]
    },
    {
      name: "通过人数",
      type: "line",
      stack: "Total4",
      smooth: true,
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      showSymbol: false,
      areaStyle: {
        opacity: 1,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(132, 223, 189 , 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(132, 223, 189, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [10, 13, 15, 11, 17, 11, 19]
    }
  ]
};
const ecOptionLong = {
  color: ["#525fff"],
  tooltip: {
    show: true,
    formatter: function(param: any) {
      return `<div style="display:flex;justify-content:space-between; width:120px;">参加面试人数<span></span>${param.data.other.all}</div><div style="display:flex;justify-content:space-between; width:120px;">完成面试人数<span>${param.data.other.finish}</span></div><div style="display:flex;justify-content:space-between; width:120px;">面试完成率<span>${param.data.other.ratio}%</span></div>`;
    }
  },

  grid: {
    left: "0%",
    right: "0%",
    bottom: "0%",
    top: "5%",
    containLabel: true
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: true,
      data: [
        "9点前",
        "9-10点",
        "10-11点",
        "11-12点",
        "12-13点",
        "13-14点",
        "14-15点",
        "15-16点",
        "16-17点",
        "17-18点",
        "18-19点",
        "19-20点",
        "20-21点",
        "21点后"
      ],
      axisTick: {
        show: false,
        inside: true, //刻度里外
        align: "center"
      },
      axisLine: {
        lineStyle: {
          color: "rgba(28, 28, 28, 0.20)"
        }
      },
      axisLabel: {
        interval: 0,
        color: "rgba(16, 16, 23, 1)"
      }
    }
  ],
  yAxis: [
    {
      type: "value",
      minInterval: 1,
      axisTick: {
        // show: false,
      },
      label: {
        color: "rgba(28, 28, 28, 0.40)"
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ["rgba(28, 28, 28, 0.05)"]
        }
      }
    }
  ],
  series: [
    {
      name: "候选人",
      type: "bar",
      stack: "Total",
      smooth: false,
      // barWidth: 52, // 柱图宽度
      barMaxWidth: 52, // 最大宽度
      lineStyle: {
        width: 1.5,
        cap: "round"
      },
      itemStyle: {
        normal: {
          //柱形图圆角，初始化效果
          barBorderRadius: [6, 6, 0, 0]
        }
      },

      showSymbol: true, //拐点
      symbol: "circle",
      symbolSize: 7,
      areaStyle: {
        opacity: 0,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(82, 95, 255, 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(82, 95, 255, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [0],
      animationEasing: "bounceOut",
      animationDuration: 1500
    }
  ]
};

export { ecOptionLD, ecOptionLong };

export class CandidateCountFinish extends Model {
  all = 0; // 全部
  noAudit = 0; // 评估-待评估
  auditPass = 0; // 评估-通过
  auditWait = 0; // 评估-待定
  auditRefuse = 0; // 评估-拒绝
  aiRecommendStatusNotRecommend = 0; // AI推荐-不推荐
  aiRecommendStatusNormal = 0; // AI推荐-一般
  aiRecommendStatusRecommend = 0; // AI推荐-推荐
  aiRecommendStatusVeryRecommend = 0; // AI推荐-非常推荐
  isAutoSubmit = 0; // 自动交卷
}
export class CandidateCountResponse extends Model {
  all = 0; // 全部人数
  notSignIn = 0; // 未签到
  signIn = 0; // 已签到
  answering = 0; // 答题中
  finish: CandidateCountFinish = new CandidateCountFinish(); // 已交卷
  inviteNumber = 0; // 邀请
  joinNumber = 0; // 参面
  finishNumber = 0;
}

// 单面试或全公司候选人数量统计
export class CandidateCount extends Model {
  /* params参数信息：
  companyId
  userId
  examId  // 面试id筛选 否则全公司下
  examType
  */
  static get(params: {
    companyId?: number;
    userId?: number;
    examId: number | string;
  }) {
    return request
      .post("/aiExam/dashboard/candidateCount", {
        ...params,
        examType: V.getExamType
      })
      .then(res => {
        return new CandidateCountResponse().assign(res.data.data);
      });
  }
}
